@if (!running && config.mask) {
  <div class="onboarding__mask" (click)="handleMask()"></div>
}
@if (item) {
  <div
    class="onboarding__light"
    [class.onboarding__light-hide]="running"
    [attr.style]="item.lightStyle"
    nz-popover
    #popover="nzPopover"
    [nzPopoverTitle]="item.title"
    [nzPopoverContent]="content"
    [nzPopoverVisible]="!running"
    [nzPopoverTrigger]="null"
    [nzPopoverPlacement]="item.position"
    [nzPopoverOverlayClassName]="item.className"
    [nzPopoverOverlayStyle]="{ 'max-width.px': item.width, direction: dir }"
    [nzNoAnimation]="true"
  ></div>
  <ng-template #content>
    <ng-container *nzStringTemplateOutlet="item.content">
      <div [innerHTML]="item.content"></div>
    </ng-container>
    <div class="flex-center-between onboarding__footer">
      <span class="onboarding__total">
        @if (config.showTotal) {
          {{ active + 1 }}/{{ max }}
        }
      </span>
      <div class="onboarding__btns">
        @if (!last && item.skip !== null && item.skip !== undefined) {
          <a nz-button nzType="link" (click)="to('skip')" nzSize="small" data-btnType="skip">
            <ng-container *nzStringTemplateOutlet="item.skip">{{ item.skip }}</ng-container>
          </a>
        }
        @if (!first && item.prev !== null) {
          <a nz-button (click)="to('prev')" nzSize="small" data-btnType="prev">
            <ng-container *nzStringTemplateOutlet="item.prev">{{ item.prev }}</ng-container>
          </a>
        }
        @if (!last && item.next !== null && item.next !== undefined) {
          <a nz-button (click)="to('next')" nzType="primary" nzSize="small" data-btnType="next">
            <ng-container *nzStringTemplateOutlet="item.next">{{ item.next }}</ng-container>
          </a>
        }
        @if (last && item.done !== null && item.done !== undefined) {
          <a nz-button (click)="to('done')" nzType="primary" nzSize="small" data-btnType="done">
            <ng-container *nzStringTemplateOutlet="item.done">{{ item.done }}</ng-container>
          </a>
        }
      </div>
    </div>
  </ng-template>
}
